import {
  getBadgeName,
  checkIsLowStock,
  checkIsOutOfStock,
  checkIsFinalPriceReq,
  getFinalPrice,
  getPercentOffValue,
  getAmountOffValue,
  getRegularPrice,
  componentCheckSize,
} from "../../../../utils/helperServices";
import labels from "../../../../config/labels";
import LabelText from "../../../atoms/label/LabelText";
import ProductCards from "../../../molecules/ProductCards/ProductCards";
const {
  Container,
  CustomContainer,
} = require("../../../atoms/DependencyHelper");
import styles from "./RecentlyViewed.module.scss";
import * as Analytics from "../../../../services/analyticsUtag";

const RecentlyViewed = (props) => {
  const isTablet = componentCheckSize() <= 768;

  const handleBuyNow = (product) => {
    Analytics.link({
      ...Analytics.getUtagData(),
      link_type: "o",
      link_name: "checkout: order history: buy now",
      link_url: `/product-details/${product.sku}`,
    });
  };

  const renderRecentlyViewed = () => {
    return (
      <>
        {props.recentViewed && props.recentViewed.length ? (
          <CustomContainer className={`d-flex mb-5 pl-md-0 ${styles.cards}`}>
            {props.recentViewed.map((item) => (
              <CustomContainer
                className={`d-flex mr-s  ${styles.card}`}
                key={item.sku}
              >
                <ProductCards
                  buttonStyleRequired={true}
                  priceRequired
                  maximumPrice={
                    item.price_range.maximum_price.regular_price.value
                  }
                  minimumPrice={
                    getAmountOffValue(item) === "0"
                      ? getFinalPrice(item) !== "0"
                        ? getFinalPrice(item)
                        : getRegularPrice(item)
                      : getRegularPrice(item)
                  }
                  promotionLabel={item?.badges != null && item?.badges_label ? item?.badges_label : ""}
                  promotionVariant={
                    item.badges_label ? getBadgeName(item.badges_label) : ""
                  }
                  promotionLabelColor={
                    item?.badges_swatch ? item.badges_swatch : null
                  }
                  itemName={item.name}
                  itemImage={item.image.url}
                  imageLabel={item.label}
                  imageUrl={item.image.url}
                  buyNowReq
                  buttonLabelReq={labels.lbl_buy_now}
                  promotionText={item.promotionText}
                  labelText={item.labelText}
                  cardHeight={isTablet ? "17.25rem" : "18.75rem"}
                  cardWidth="12.5625rem"
                  imgWidth="5rem"
                  imgHeight="5rem"
                  isLowStock={checkIsLowStock(item)}
                  isOutOfStock={checkIsOutOfStock(item)}
                  previousPriceReq
                  finalPriceReq={checkIsFinalPriceReq(item)}
                  finalPrice={getFinalPrice(item)}
                  percentOff={getPercentOffValue(item)}
                  amountOff={getAmountOffValue(item)}
                  item={item}
                  sku={item.sku}
                  priceLabelClassName={styles["price-label"]}
                  finalPriceClassLabel={styles["final-price"]}
                  offerPriceClass={styles["offer-price-box"]}
                  spacingButtonMobileClassName="recently-viewed-buyNow-btn"
                  ctaHandler={handleBuyNow}
                />
              </CustomContainer>
            ))}
          </CustomContainer>
        ) : (
          ""
        )}
      </>
    );
  };

  return (
    <CustomContainer>
      <CustomContainer className={styles["line-seperator"]} />
      <CustomContainer>
        {props.recentViewed && props.recentViewed.length > 0 && (
          <LabelText className={styles["recent-heading"]}>
            You recently viewed:
          </LabelText>
        )}
        {renderRecentlyViewed()}
      </CustomContainer>
    </CustomContainer>
  );
};

export default RecentlyViewed;
